import { useEffect } from 'react'

interface Fullstory {
  identify(uid: string, userVars?: object): void
  setUserVars(userVars: object): void
  getCurrentSessionURL(now?: boolean): string
  log(msg: string): void
  log(level: string, msg: string): void
  shutdown(): void
  restart(): void
  consent(consent: boolean): void
  event(eventName: string, eventProperties: object): void
  anonymize(): void
}

export const useFsIdentify = (userId: string) => {
  useEffect(() => {
    if (!('FS' in window)) return
    ;(window.FS as Fullstory).setUserVars({
      uid: userId,
    })
  }, [userId])
}
